import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=6c774b02&scoped=true&"
import script from "./HomePage.vue?vue&type=script&lang=js&"
export * from "./HomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c774b02",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/HomePage.vue
// module id = 96
// module chunks = 0